import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import './styles.scss';
import { getSingleEvent, eventGoing, eventNotGoing, updateEventsRequest } from '../../../../actionCreators/events';
import {
  toggleLikeRequest,
  toggleCommentLikeRequest,
  postCommentRequest,
  getFeedItemDetailsRequest
} from '../../../../actionCreators/feedActions';
import { addAlertToAlertsList } from '../../../../actionCreators/globalAlerts';
import { RESET_EVENT_BY_ID_SUCCESS } from '../../../../constants/actionTypes';

import EventDetailsItem from '../../../../components/EventDetails/components/EventDetailsItem';

const EventItem = (props) => {
  const params = useParams();
  const { postId } = params;
  
  useEffect(() => {
    props.getEventById(postId);

    return () => {
      props.resetSingleEventById();
    };
  }, []);

  return (
    <div className="event-container">
      <EventDetailsItem
        event={props.singleEvent}
        eventGoing={props.eventGoing}
        eventNotGoing={props.eventNotGoing}
        updateEvent={props.updateEvent}
        getFeedItemDetails={props.getFeedItemDetails}
        userImageUrl={props.userImageUrl}
        postComment={props.postComment}
        toggleLike={props.toggleLike}
        toggleCommentLike={props.toggleCommentLike}
        addAlertToAlerts={props.addAlertToAlerts}
        currentUser={props.currentUser}
      />
    </div>
  );
};

const EventItemContainer = (props) => {
  const state = useSelector((state) => ({
    postReportTypes: state.feed.postReportTypes,
    reportPostRequestSuccessful: state.feed.reportPostRequestSuccessful,
    currentUser: state.currentUser,
    singleEvent: state.events.singleEvent,
    userImageUrl: state.currentUser.signInData.imageUrl,
    currentUser: state.currentUser,
  }));

  const dispatch = useDispatch();

  const actions = {
    addAlertToAlerts: payload => dispatch(addAlertToAlertsList(payload)),
    getEventById: (payload) => dispatch(getSingleEvent(payload)),
    eventGoing: (payload) => dispatch(eventGoing(payload)),
    eventNotGoing: (payload) => dispatch(eventNotGoing(payload)),
    toggleLike: (payload) => dispatch(toggleLikeRequest(payload)),
    toggleCommentLike: (payload) => dispatch(toggleCommentLikeRequest(payload)),
    getFeedItemDetails: (payload) => dispatch(getFeedItemDetailsRequest(payload)),
    postComment: (payload) => dispatch(postCommentRequest(payload)),
    updateEvent: (payload) => dispatch(updateEventsRequest(payload)),
    resetSingleEventById: () =>
          dispatch({
            type: RESET_EVENT_BY_ID_SUCCESS,
            payload: '',
          }),
  };

  return <EventItem {...props} {...state} {...actions} />;
};

export default EventItemContainer;
